// extracted by mini-css-extract-plugin
export default {"cargo-dropdown":"DropdownWithRadioButtonSelect_cargo-dropdown__6SQVf","label":"DropdownWithRadioButtonSelect_label__TxWiu"};